import { createDrawerEventBinder, plainText } from './cart_drawer_utils.js';

export function initCartDrawerSuggestionActions({ openAfterAdd, drawerSelector }) {
    const onDrawer = createDrawerEventBinder(drawerSelector);

    // Navegação do carrossel e inclusão de produtos sugeridos.
    onDrawer('click', '[data-cart-drawer-suggest-scroll]', function() {
        const track = $(this).closest('.cart-drawer-suggest').find('.cart-drawer-suggest__track')[0];
        const direction = parseInt($(this).attr('data-cart-drawer-suggest-scroll'), 10);

        track.scrollBy({ left: direction * track.clientWidth * 0.85, behavior: 'smooth' });
    });

    function showSuggestError($card, message) {
        $card.find('.cart-drawer-suggest__error').text(message).prop('hidden', false);
    }

    // Mensagem de erro do add (opção obrigatória, estoque...) em texto puro
    function addErrorMessage(json, fallback) {
        let message = '';

        if (json.error_stock) {
            message = json.error_stock;
        } else if (json.error && typeof json.error === 'object') {
            const first = json.error.option ? Object.values(json.error.option)[0] : Object.values(json.error)[0];
            message = typeof first === 'string' ? first : '';
        }

        return plainText(message) || fallback;
    }

    // Rastreamento do add feito pela sugestão: mesmos eventos disparados na página do produto
    function trackSuggestionAdd(json) {
        if (json.ga4 && typeof window.sendAddCartGa4 === 'function') {
            window.sendAddCartGa4({ currency: json.currency, value: json.item_price, items: [json.add_to_cart] }, json.config_google_analytics);
        }

        if (json.script_facebook_default_conversion) {
            $('body').append(json.script_facebook_default_conversion);
        }

        if (json.dynamic_remarketing && json.params_dynamic_remarketing && typeof window.sendAddCartGa4 === 'function') {
            window.sendAddCartGa4({
                items: json.params_dynamic_remarketing.items,
                send_to: json.params_dynamic_remarketing.ads_tag_id
            }, json.params_dynamic_remarketing.ads_tag_id);
        }

        if (json.pushnews) {
            window.IlabsPush = window.IlabsPush || [];
            window.IlabsPush.push(['ecommerce.itemAddedToCart']);
        }
    }

    window.cartDrawerTrackAdd = trackSuggestionAdd;

    // Sugestões: adicionar ao carrinho pelo próprio card
    onDrawer('click', '[data-cart-drawer-suggest-add]', function() {
        const $button = $(this);
        const $card = $button.closest('.cart-drawer-suggest__card');
        const option_id = $card.attr('data-option-id');
        const $select = $card.find('.cart-drawer-suggest__select');
        const data = { product_id: $card.attr('data-product-id'), quantity: 1, '__csrf': $('#__csrf').val() };

        $card.find('.cart-drawer-suggest__error').prop('hidden', true);

        if ($select.length) {
            if (!$select.val()) {
                showSuggestError($card, $card.attr('data-msg-choose'));
                return;
            }

            data['option[' + option_id + ']'] = $select.val();
        }

        $button.prop('disabled', true).addClass('is-loading');

        $.ajax({
            url: 'index.php?route=checkout/cart/add&cart_drawer=1',
            type: 'post',
            data: data,
            dataType: 'json',
            success: function(json) {
                if (json.open_cart_drawer) {
                    trackSuggestionAdd(json);

                    openAfterAdd(json);
                    return;
                }

                showSuggestError($card, addErrorMessage(json, $card.attr('data-msg-error')));
            },
            error: function() {
                showSuggestError($card, $card.attr('data-msg-error'));
            },
            complete: function() {
                $button.prop('disabled', false).removeClass('is-loading');
            }
        });
    });

    onDrawer('change', '.cart-drawer-suggest__select', function() {
        $(this).closest('.cart-drawer-suggest__card').find('.cart-drawer-suggest__error').prop('hidden', true);
    });
}
